import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { format } from "date-fns";

export const BlogCard = ({ post }) => {
  const formattedDate = post.created_at
    ? format(new Date(post.created_at), "MMMM d, yyyy")
    : "";

  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group block border border-neutral-800 card-hover bg-neutral-900"
      data-testid={`blog-card-${post.slug}`}
    >
      {/* Image */}
      {post.image_url && (
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={post.image_url}
            alt={post.title}
            className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
          />
        </div>
      )}

      {/* Content */}
      <div className="p-6 md:p-8">
        <div className="flex items-center gap-4 mb-4 text-sm text-gray-400">
          <span>{formattedDate}</span>
          <span>•</span>
          <span>{post.author}</span>
        </div>

        <h3 className="font-heading text-xl md:text-2xl font-semibold text-white mb-3 group-hover:underline decoration-1 underline-offset-4">
          {post.title}
        </h3>

        <p className="text-gray-400 leading-relaxed mb-4 line-clamp-3">
          {post.excerpt}
        </p>

        <div className="flex items-center gap-2 text-sm uppercase tracking-widest font-medium text-white">
          Read More
          <ArrowUpRight className="w-4 h-4" />
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
